import React from 'react';
import { Chip } from '@mui/material';

const statusMap = {
  completed: { color: 'success', label: 'Completed' },
  queued: { color: 'default', label: 'Queued' },
  processing: { color: 'warning', label: 'Processing' },
  failed: { color: 'error', label: 'Failed' },
  ok: { color: 'success', label: 'OK' },
  error: { color: 'error', label: 'Error' },
  pending: { color: 'info', label: 'Pending' },
};

const StatusBadge = ({ status, size = 'small' }) => {
  const config = statusMap[status?.toLowerCase()] || { color: 'default', label: status || 'Unknown' };

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500, textTransform: 'capitalize' }}
    />
  );
};

export default StatusBadge;
